import React from 'react';
import styled from 'styled-components';
import { fontSize } from '../../mixins';
import { CheckOrangeCircle, CheckWhiteCircle } from './icons';


const StyledTitle = styled.div`
  font-family: 'SF Pro Text', sans-serif;
  font-weight: 700;
  ${fontSize(18)};
  line-height: 21px;
  text-align: center;
  color: #fff;
  margin-bottom: 24px;
`;

const StyledWrapper = styled.div`
  border: 1px solid #ffffff;
  background: linear-gradient(
    111.55deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.04) 100%
  );
  border-radius: 33px;
  margin-top: 100px;
  margin-bottom: 20px;
  padding: 56px 42px;
  min-width: 327px;
  
  @media screen and (max-width: 430px) {
    padding: 0 42px;
    min-width: 320px;
    margin-top: 20px;
    background: none;
    border: unset;
  }
  
  @media screen and (max-height: 670px) {
    overflow-x: scroll;
  }
`;

const StyledLatamIcon = styled.div`
  width: 15%;
  display: flex;
  justify-content: flex-start;
`;

const StyledDiscountWrapper = styled.div`
  width: 100%;
  height: 20px;
  padding-left: 12px;
  padding-right: 12px;
  background: #f2994a;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledDiscountTitle = styled.span`
  font-family: 'SF Pro Text', sans-serif;
  font-weight: 700;
  ${fontSize(10)};
  line-height: 16px;
  letter-spacing: -0.46px;
  color: #fff;
`;

const StyledDiscountPrice = styled.span`
  font-family: 'SF Pro Text', sans-serif;
  font-weight: 700;
  ${fontSize(13)};
  line-height: 16px;
  letter-spacing: -0.46px;
  color: #fff;
`;

const StyledLatamList = styled.ul`
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`;

const StyledLatamLi = styled.li`
  width: 100%;
  position: relative;
  background: linear-gradient(96.24deg, #454545 1.53%, #2f2f2f 98.89%);
  border: ${(props) => props.active ? '1px solid #FBA253' : '1px solid transparent'};
  border-radius: 8px;
  margin-bottom: 8px;
  &:nth-child(2) {
    border-top-left-radius: unset;
    border-top-right-radius: unset;
  }

  button {
    width: 100%;
    height: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    padding: 11px 12px;
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }
`;

const StyledPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 50%;
`;

const StyledLatamName = styled.span`
  font-family: 'SF Pro Text', sans-serif;
  font-weight: 800;
  ${fontSize(16)};
  line-height: 16px;
  margin-bottom: 8px;
`;

const StyledPriceWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

const StyledOldPrice = styled.span`
  font-family: 'SF Pro Text', sans-serif;
  font-weight: 400;
  ${fontSize(12)};
  line-height: 12px;
  letter-spacing: -0.46px;
  color: #b1b1b1;
  text-decoration: line-through;
  margin-right: 4px;
`;

const StyledNewPrice = styled.span`
  font-family: 'SF Pro Text', sans-serif;
  font-weight: 700;
  ${fontSize(14)};
  line-height: 14px;
  letter-spacing: -0.46px;
  color: ${(props) => (props.active ? '#FBA253' : '#33CCB7')};
`;

const StyledWeekPriceContainer = styled.div`
  width: 81px;
  height: 44px;
  background: ${(props) => props.active ? 'linear-gradient(103.17deg, #F4A056 24.04%, #DF6D08 147.98%);' : '#434343'};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledWeekPrice = styled.span`
  color: ${(props) => (props.active ? '#ffffff' : '#7D7D7D')};
  letter-spacing: -0.460567px;
  font-family: 'SF Pro Text', sans-serif;
  font-weight: 700;
  ${fontSize(16)};
  line-height: 100%;
  margin-bottom: 2px;
`;

const StyledTitleWeek = styled.span`
  color: ${(props) => (props.active ? '#ffffff' : '#7D7D7D')};
  letter-spacing: -0.460567px;
  font-family: 'SF Pro Text', sans-serif;
  font-weight: 400;
  ${fontSize(12)};
  line-height: 100%;
`;

const StyledLatamOptions = styled.ul`
  list-style: none;
  background: #454545;
  border-radius: 8px;
  padding-inline-start: 36px;
  padding-top: 8px;
  padding-bottom: 8px;
`;

const StyledLatamOption = styled.li`
  position: relative;
  ${fontSize(14)};
  line-height: 22px;
  letter-spacing: -0.460567px;
  color: #ffffff;
  padding: 9px 0;
  font-family: 'SF Pro Text', sans-serif;
  &::before {
    content: '';
    width: 12px;
    height: 8px;
    background-image: url('../images/orange-checkmark.png');
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    left: -24px;
    top: 17px;
  }
`;


const LatamPlan = ({plan, onPlanClick, currentPlans}) => {
    const renderLatamOption = (i, index) => {
        const isActive = plan === i.id;
        return <React.Fragment key={i.id}>
            {i.bestseller && (
                <StyledDiscountWrapper>
                    <StyledDiscountTitle>BEST SELLER</StyledDiscountTitle>
                    <StyledDiscountPrice>{i.bestsellerDiscount} OFF</StyledDiscountPrice>
                </StyledDiscountWrapper>
            )}
            <StyledLatamLi active={isActive}>
                <button onClick={() => onPlanClick(i.id)} id={'plan-button-' + (index + 1)}>
                    <StyledLatamIcon>
                        {isActive ? CheckOrangeCircle : CheckWhiteCircle}
                    </StyledLatamIcon>
                    <StyledPriceContainer>
                        <StyledLatamName>{i.title.toUpperCase()}</StyledLatamName>
                        <StyledPriceWrapper>
                            <StyledOldPrice active={isActive}>
                                {i.oldPrice}
                            </StyledOldPrice>
                            <StyledNewPrice active={isActive}>{i.price}</StyledNewPrice>
                        </StyledPriceWrapper>
                    </StyledPriceContainer>
                    <StyledWeekPriceContainer active={isActive}>
                        <StyledWeekPrice active={isActive}>
                            {i.pricePerWeek}
                        </StyledWeekPrice>
                        <StyledTitleWeek active={isActive}>per week</StyledTitleWeek>
                    </StyledWeekPriceContainer>
                </button>
            </StyledLatamLi>
        </React.Fragment>;
    };


    return (
        <StyledWrapper>
            <StyledTitle>Unlock All Access</StyledTitle>
            <StyledLatamList>
                {currentPlans.map(renderLatamOption)}
            </StyledLatamList>
            <StyledLatamOptions>
                <StyledLatamOption>Unlimited Place Alerts</StyledLatamOption>
                <StyledLatamOption>Unlimited Live-Locating</StyledLatamOption>
                <StyledLatamOption>Location History</StyledLatamOption>
            </StyledLatamOptions>
        </StyledWrapper>
    );
};


export default LatamPlan;